import { useState, useCallback } from 'react';
import axios from 'axios';
import { YoyakuApiUrl } from '../conf/config';
import { HandlerSlot, ReqSetSlot, ResAddSlot } from '../types/ce-api/Slots';

export const useSetSlot = () => {
  const [resSetSlot, setResSetSlot] = useState<ResAddSlot>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const setSlot = useCallback(<T extends HandlerSlot | ReqSetSlot>(value: T, mode: number) => {
    setError(false);
    setLoading(true);
    console.log('mode=' + mode);
    if (typeof value == `object`) {
      let req: HandlerSlot = {
        slot_id: '',
        group_id: '',
        slot_title: '',
        app_uid: '',
        app_label: '',
        start_datetime: '',
        end_datetime: '',
        alert_to1: '',
        alert_to2: '',
        sametime_slot_num: 0,
        rgb: '',
        message: '',
        close_flg: 0,
        the_month: '',
        the_week_monday: '',
        the_day: '',
        src_date: '',
        dst_date: '',
        repeat_num: 0,
      };

      if (mode == 2 && value.slot_id != '') {
        req.slot_id = value.slot_id;
      }
      req.group_id = value.group_id;
      req.slot_title = value.slot_title;
      req.app_uid = value.app_uid;
      req.app_label = value.app_label;
      req.start_datetime = value.start_datetime;
      req.end_datetime = value.end_datetime;
      req.sametime_slot_num = value.sametime_slot_num;
      req.message = value.message;
      req.alert_to1 = value.alert_to1;
      req.alert_to2 = value.alert_to2;
      req.close_flg = value.close_flg;

      let token: string | null = sessionStorage.getItem('token');
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      let api: string = '';
      if (mode == 1) {
        api = 'slots';
      }
      if (mode == 2) {
        api = 'slots/' + value.slot_id;
      }
      console.log('api=' + api);

      if (token != null) {
        axios
          .post(`${YoyakuApiUrl}/ac/api/v1/${api}`, req, config)
          .then((res) => {
            console.log(res.data);
            setResSetSlot(res.data);
          })
          .catch((error) => {
            console.log(error);
            setError(true);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }
  }, []);

  return { setSlot, resSetSlot, loading, error };
};
